import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FALLBACK_MENU, hasCategories } from "../../data/fallback";
import { API_URL } from "../../config/api";

const PUBLIC_TOKEN = "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJkZW5pcy5taW1pbmlAY2xpY2thbGJhbmlhLmNvbSIsImlhdCI6MTc1MDk4MjU3NywiZXhwIjoxNzUxMjQxNzc3fQ.yQ3xGQEfpj62ruJoLJYOl3966g55OlyofRqjoAHzu";
// const PUBLIC_TOKEN = process.env.REACT_APP_STATIC_TOKEN;



//     const API_URL =
// process.env.NODE_ENV === "development"
//     ? process.env.REACT_APP_API_URL_LOCAL
//     : process.env.REACT_APP_API_URL_PROD;


// Async thunk to fetch products from API
export const fetchProductsFromApi = createAsyncThunk(
    'products/fetchFromApi',
    // @ts-ignore
    async ({ businessid }, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_URL}/api/menu-item/business/${businessid}`, {
                headers: {
                    Authorization: `Bearer ${PUBLIC_TOKEN}`,
                    'Content-Type': 'application/json',
                },
            });


            if (!response.ok) {
                const errorData = await response.json().catch(() => ({})); // Catch in case response is not JSON
                const errorMessage = errorData?.message || 'Failed to fetch products';
                throw new Error(errorMessage);
            }
            const text = await response.text();

            try {
                const data = JSON.parse(text);
                return data;
            } catch (parseError) {
                throw new Error('Invalid JSON received from server');
            }
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

const initialState = {
    products: [],
    status: 'idle',
    error: null,
    // True while the menu on screen is the bundled copy rather than the API's answer.
    usedFallback: false,
};

const productsSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductsFromApi.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchProductsFromApi.fulfilled, (state, action) => {
                // An empty answer is no more useful to a guest than a failed one.
                const live = hasCategories(action.payload);
                state.status = 'succeeded';
                state.products = live ? action.payload : FALLBACK_MENU;
                state.usedFallback = !live;
                state.error = null;
            })
            .addCase(fetchProductsFromApi.rejected, (state, action) => {
                // The status stays honest, but show the bundled menu rather than nothing:
                // a guest at the table wants the food, not the reason the request failed.
                state.status = 'failed';
                state.products = FALLBACK_MENU;
                state.usedFallback = true;
                // @ts-ignore
                state.error = action.payload;
            });

    },

});


export default productsSlice.reducer;


export const selectAllProducts = (state) => state.products.products;
export const selectProductsStatus = (state) => state.products.status;
export const selectProductsError = (state) => state.products.error;
export const selectProductsUsedFallback = (state) => state.products.usedFallback;

